<template>
  <b-row>
    <b-col>
      <b-card>
        <div>
          <b-row v-if="item.invoiceCorrectionOf">
            <div class="col-xs-12 col-md-12">
              <b-button v-b-toggle.collapse-1 variant="primary" class="w-100 mb-2">{{ $t('views.exsbinvoices.form.correctionOf') }}</b-button>
              <b-collapse id="collapse-1" class="mt-2">
                <InvoiceShow :item="item.invoiceCorrectionOf"></InvoiceShow>
                <hr>
              </b-collapse>
            </div>
          </b-row>
          <b-row>
            <b-col>
              <p v-if="item.number"><b>{{$t('views.exsbinvoices.show.number')}}:</b> {{ item.number }}</p>
              <p><b>{{$t('views.exsbinvoices.show.batchNumber')}}:</b> {{ item.batchNumber.name }}</p>
              <p><b>{{$t('views.exsbinvoices.show.paymentWay')}}:</b> {{ item.paymentWay.name }}</p>
              <p><b>{{$t('views.exsbinvoices.show.invoiceStatus')}}:</b> {{ item.invoiceStatus.name }}</p>
              <p><b>{{$t('views.exsbinvoices.show.issueDate')}}:</b> {{ item.issueDate }}</p>
              <p><b>{{$t('views.exsbinvoices.list.sent')}}: </b><span v-if="item.sent === 0">{{$t('views.promotions.form.no')}}</span><span
                  v-if="item.sent === 1">{{$t('views.promotions.form.yes')}}</span></p>
            </b-col>
            <b-col>
              <p><b>{{$t('views.exsbinvoices.show.issuePlace')}}:</b> {{ item.issuePlace }}</p>
              <p v-if="item.sellDate !== 'InvalidDate'">
                <b>
                  {{$t('views.exsbinvoices.show.sellDate')}}:
                </b>
                <span>
                    {{ item.sellDate }}
                  </span>
              </p>
              <p><b>{{$t('views.exsbinvoices.show.paymentDeadline')}}:</b> {{ item.paymentDeadline }}</p>
              <p><b>{{$t('views.exsbinvoices.show.paid')}}:</b> {{ item.paid }}</p>
              <p><b>{{$t('views.exsbinvoices.show.toPay')}}:</b> {{ item.toPay }}</p>
              <p><b>{{$t('views.exsbinvoices.form.gtu')}}: </b> {{ item.gtu }} </p>
              <p><b>{{$t('views.exsbinvoices.form.pkwiu')}}: </b> {{ item.pkwiu }} </p>
            </b-col>
            <div v-if="item.accepted === 0" class="d-none d-xl-inline-block position-absolute w-100">
              <b-badge variant="warning" class="h6 float-right">{{ $t('views.exsbinvoices.form.invoiceNotAccepted') }}
              </b-badge>
            </div>
          </b-row>
          <b-row class="mt-3">
            <b-col>
              <h6>{{$t('views.exsbinvoices.show.sellerData')}}:</h6>
              <p><b>{{$t('views.exsbinvoices.show.sellerName')}}:</b> {{ item.sellerName }}</p>
              <p><b>{{$t('views.exsbinvoices.show.sellerNip')}}:</b> {{ item.sellerNip }}</p>
              <p><b>{{$t('views.exsbinvoices.show.sellerPostcode')}}:</b> {{ item.sellerPostcode }}</p>
              <p><b>{{$t('views.exsbinvoices.show.sellerCity')}}:</b> {{ item.sellerCity }}</p>
              <p><b>{{$t('views.exsbinvoices.show.sellerStreet')}}:</b> {{ item.sellerStreet }}</p>
              <p><b>{{$t('views.exsbinvoices.form.sellerStreetNumber')}}:</b> {{ item.sellerStreetNumber }}</p>
              <p><b>{{$t('views.exsbinvoices.form.sellerPlaceNumber')}}:</b> {{ item.sellerPlaceNumber }}</p>
            </b-col>
            <b-col>
              <h6>{{$t('views.exsbinvoices.show.buyerData')}}:</h6>
              <p><b>{{$t('views.exsbinvoices.show.buyerName')}}: </b>
              <router-link :to="{name: 'FirmShow', params: { id: item.idUserData['@id'] }}">
                <span>{{ item.buyerName }}</span>
              </router-link>
              <p><b>{{$t('views.exsbinvoices.show.buyerNip')}}:</b> {{ item.buyerNip }}</p>
              <p><b>{{$t('views.exsbinvoices.show.buyerPostcode')}}:</b> {{ item.buyerPostcode }}</p>
              <p><b>{{$t('views.exsbinvoices.show.buyerCity')}}:</b> {{ item.buyerCity }}</p>
              <p><b>{{$t('views.exsbinvoices.show.buyerStreet')}}:</b> {{ item.buyerStreet }}</p>
              <p><b>{{$t('views.exsbinvoices.form.buyerStreetNumber')}}:</b> {{ item.buyerStreetNumber }}</p>
              <p><b>{{$t('views.exsbinvoices.form.buyerPlaceNumber')}}:</b> {{ item.buyerPlaceNumber }}</p>
            </b-col>
          </b-row>
          <b-row v-if="ableToEditInvoice">
            <b-col>
              <b-btn @click="menageData()" class="mt-0 mb-3">{{$t('views.exsbinvoices.show.menageData')}}</b-btn>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <table class="text-center border-table">
                <thead class="text-center">
                <th>
                  <p>{{$t('views.exsbinvoices.show.invoicePositionHeaders.lp')}}</p>
                </th>
                <th>
                  <p>{{$t('views.exsbinvoices.show.invoicePositionHeaders.item')}}</p>
                </th>
                <th>
                  <p>{{$t('views.exsbinvoices.show.invoicePositionHeaders.priceNettoPerUnit')}}</p>
                </th>
                <th>
                  <p>{{$t('views.exsbinvoices.show.invoicePositionHeaders.quantity')}}</p>
                </th>
                <th>
                  <p>{{$t('views.exsbinvoices.show.invoicePositionHeaders.measure')}}</p>
                </th>
                <th>
                  <p>{{$t('views.exsbinvoices.show.invoicePositionHeaders.valueNetto')}}</p>
                </th>
                <th>
                  <p>{{$t('views.exsbinvoices.show.invoicePositionHeaders.vatRate')}}</p>
                </th>
                <th>
                  <p>{{$t('views.exsbinvoices.show.invoicePositionHeaders.vatAmount')}}</p>
                </th>
                <th>
                  <p>{{$t('views.exsbinvoices.show.invoicePositionHeaders.valueBrutto')}}</p>
                </th>
                </thead>
                <template v-for="(position, index) in item.invoicePositions">
                  <tr v-bind:key="'invoicePositionRow-' + index">
                    <td>{{ index + 1 }}.</td>
                    <td>{{ position.item ? position.item.name : position.customItem }}</td>
                    <td>{{ position.priceNettoPerUnit }}</td>
                    <td>{{ position.quantity }}</td>
                    <td>{{ position.measure.name }}</td>
                    <td>{{ position.valueNetto }}</td>
                    <td v-if="position.vatRate">{{ position.vatRate.value }}</td>
                    <td v-else></td>
                    <td>{{ position.vatAmount }}</td>
                    <td>{{ position.valueBrutto }}</td>
                  </tr>
                  <tr v-if="position.discount" :key="'positionDiscount_'+index">
                    <td></td>
                    <td>
                      <h6>{{$t('views.exsbinvoices.form.discount')}}</h6>
                      <span v-if="position.discountDescription">{{position.discountDescription}}</span>
                    </td>
                    <td>
                      {{ position.discount }}
                    </td>
                    <td colspan="6"></td>
                  </tr>
                </template>
                <tr v-for="(totalSum, index) in item.totalSums" v-bind:key="'totalSum' + index">
                  <td v-if="totalSum.totalValueNetto > 0" style="border:none;"></td>
                  <td v-if="totalSum.totalValueNetto > 0" style="border:none;"></td>
                  <td v-if="totalSum.totalValueNetto > 0" style="border:none;"></td>
                  <td v-if="totalSum.totalValueNetto > 0" style="border:none;"></td>
                  <td v-if="totalSum.totalValueNetto > 0" style="border:none;"></td>
                  <td v-if="totalSum.totalValueNetto > 0">{{ totalSum.totalValueNetto }}</td>
                  <td v-if="totalSum.totalValueNetto > 0">{{ totalSum.vatRange }}%</td>
                  <td v-if="totalSum.totalValueNetto > 0">{{ totalSum.totalVatAmount }}</td>
                  <td v-if="totalSum.totalValueNetto > 0">{{ totalSum.totalValueBrutto }}</td>
                </tr>
                <tr>
                  <td style="border:none;"></td>
                  <td style="border:none;"></td>
                  <td style="border:none;"></td>
                  <td style="border:none;"></td>
                  <td>{{ $t('views.exsbinvoices.show.vatSum') }}:</td>
                  <td>{{ item.totalValueNetto }}</td>
                  <td style="border:none;">-</td>
                  <td>{{ item.totalVatAmount }}</td>
                  <td>{{ item.totalValueBrutto }}</td>
                </tr>
              </table>
            </b-col>
          </b-row>
          <b-row v-if="ableToEditInvoice">
            <b-col>
              <b-btn @click="menagePositions()">{{$t('views.exsbinvoices.show.menagePositions')}}</b-btn>
            </b-col>
          </b-row>
          <b-row v-if="item.comments">
            <b-col>
              <p><b>{{$t('views.exsbinvoices.show.comments')}}:</b> {{ item.comments }}</p>
            </b-col>
          </b-row>
        </div>
      </b-card>
    </b-col>
  </b-row>
</template>
<script>
import ShowInvoiceMixins from '@/components/Dashboard/Views/common/ShowInvoiceMixins'

export default {
  name: 'InvoiceShow',
  mixins: [ShowInvoiceMixins],
  props: {
    ableToEditInvoice: {},
    item: {}
  }
}
</script>
